import { useSuspenseQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { API } from 'api';

import { SECTIONS, DOMAINS, IMPORTANCE } from '@repo/monitoring';
import { apiName, apiBasePath } from 'assets/constants';
import { ConditionForKit, ConditionType } from 'types/Conditions';

export const getConditions = async (kitId: string) => {
  const response = await API.get(
    apiName,
    `${apiBasePath}/conditions/v2/${kitId}`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.RESULTS,
        domain: DOMAINS.CONDITIONS,
        importance: IMPORTANCE.CRITICAL,
      },
      context: {
        kitId,
      },
    },
  );
  return response.result;
};
export const getConditionsQuery = (kitId?: string | null) => ({
  queryKey: [apiName, 'getConditions', kitId],
  queryFn: () => (kitId ? getConditions(kitId) : []),
});
const useConditions = ({ kitId }: { kitId?: string | null }) => {
  const conditionsQuery = useSuspenseQuery<ConditionForKit[]>(
    getConditionsQuery(kitId),
  );

  const groupedData = useMemo(() => {
    const all = conditionsQuery.data || [];
    const biomarkers = all.filter(
      condition => condition.type === ConditionType.BIOMARKER,
    );
    const associations = all.filter(
      condition => condition.type === ConditionType.ASSOCIATION,
    );

    return { all, biomarkers, associations };
  }, [conditionsQuery.data]);

  return {
    ...conditionsQuery,
    data: groupedData.all,
    biomarkers: groupedData.biomarkers,
    associations: groupedData.associations,
  };
};

export default useConditions;
